export {
    BASE_FONT_STYLESHEET_HREFS,
    FONT_PRECONNECT_ORIGINS,
    GOOGLE_FONT_STYLESHEETS,
    ICON_FONT_STYLESHEET_HREFS,
    resolveThemeFontStylesheets,
} from '@web-store-platforms/constants';
